import React, { useEffect, useState } from 'react';
import { Card } from 'primereact/card';
import { useNavigate } from 'react-router-dom';
import { classNames } from 'primereact/utils';
import style from '../styles/MobileMenu.module.css';

const MobileMenu = ({ menuItems, currentSelection }) => {
  const navigate = useNavigate();
  const [selectedIndex, setSelectedIndex] = useState(menuItems.findIndex(item => item.id === currentSelection));

  useEffect(() => {
    setSelectedIndex(menuItems.findIndex(item => item.id === currentSelection));
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentSelection]);

  function getMenuItemClass(index) {
    switch (index) {
      case 0:
        return style.menu_item_left
      case 2:
        return style.menu_item_right
      default:
        return ""
    }
  }

  return (
    <div className={style.mobile_menu}>
      {menuItems.map((item, index) => (
        <Card
          key={index}
          onClick={() => {
            setSelectedIndex(index);
            navigate(item.path)
          }}
          className={classNames(style.menu_item, selectedIndex === index && style.selected_item, getMenuItemClass(index))}
        >
          <i
            className={classNames(style.menu_icon, item.icon, selectedIndex === index && 'selected')}
          />
          <p className={style.menu_label}>
            {item.label}
          </p>
        </Card>
      ))}
    </div>
  );
};

export default MobileMenu;
